import React from 'react';
import GeneralHelpers from 'lib/helpers/GeneralHelpers';
import styled from 'styled-components';
// ANTD
import Select from 'antd/lib/select';
import Title from 'components/text/Title';

// CONSTANTS AND DESTRUCTURING
// ================================================================
const Option = Select.Option;

const OptionContent = styled.div`
  width: 100%;
  margin: 2px;
`;

const StyleWrapper = styled.div`
  .ant-select-selection,
  .ant-select-selection__rendered,
  .ant-select-selection-selected-value {
    height: 56px !important;
  }
  .ant-select-selection-selected-value {
    display: flex !important;
    align-items: center !important;
  }
`;

// EXPORTED COMPONENT
// ================================================================
const DashboardsDropdown = props => {
  const { onChange, value, dashboards } = props;
  const options = dashboards.map(dashboard => (
    <Option key={dashboard._id} value={dashboard._id}>
      <OptionContent>
        <Title style={{ margin: 0 }}>
          <img src={dashboard.icon} alt="dashboard-icon" height="40" /> {dashboard.name}
        </Title>
      </OptionContent>
    </Option>
  ));

  return (
    <StyleWrapper>
      <Select
        value={value}
        onChange={onChange}
        size="large"
        style={{ width: 305, height: 56 }}
        showSearch
        optionFilterProp="children"
        filterOption={GeneralHelpers.selectSearchFilter}
      >
        {options}
      </Select>
    </StyleWrapper>
  );
};

// EXPORT
// ================================================================
export default DashboardsDropdown;



// WEBPACK FOOTER //
// ./src/components/inputs/DashboardsDropdown/index.js